import { useFlags } from 'launchdarkly-react-client-sdk';

interface UseSectionsOrderHook {
  variationName: string;
  sections: string[];
}

export const useSectionsOrder = (): UseSectionsOrderHook => {
  const { 'sections-order': flag } = useFlags();
  const [variationName] = Object.keys(flag);
  const sections = flag[variationName] as string[];

  return { variationName, sections };
};
